import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as assessmentActionCreators from '../../../redux/modules/assessment'
import { Card, CardBody, } from 'reactstrap'
import { ItemQuestion, ItemBasicNav, ItemFeedback, } from '../AssessTest'
import { ItemAnswers, } from './AssessTestComponents'
import values from 'mout/object/values'

/*
  <AssessItemPreview
    itemNumber={props.itemNumber ? props.itemNumber - 1 : 0}
    userAssessment={props.userAssessment}
    groupUA={props.groupUA}
    subtestId={props.subtestId}
    user={props.user}
  />
*/

class AssessItemPreview extends Component {

  render() {
    const props = this.props
    const { 
      transitionCN, 
      location, 
      answersByItemAll,
    } = props
    const {
      itemNumber, lastItemNumber, userAssessment, groupUA,
      subtestId, user, items, completed
    } = this.props
    let subtest, usingGUA, itemId, item, selectedAnswer
    if (user) {
      if (user.role !== 'Student' && groupUA) {
        subtest = groupUA.destructuredSubtests[subtestId]
        usingGUA = true
      } else if (userAssessment) {
        subtest = userAssessment.destructuredSubtests[subtestId]
      }
      if (subtest) {
        itemId = subtest.items[itemNumber - 1]
        if (items) {
          item = items[itemId]
        }
        if (!usingGUA && userAssessment && userAssessment.answersByItem && userAssessment.answersByItem[subtestId]) {
          selectedAnswer = userAssessment.answersByItem[subtestId][itemId]
        }
      }
    }
    const feedback = selectedAnswer ? item && item.answers[selectedAnswer].feedback : item && values(item.answers)[0].feedback
    const cardClass = `question inactive non-math ${transitionCN} ${location === 'top' ? 'prev' : 'next'}`
    // Need to use ItemAnswers from different location!
    // activeItem = item
    // isGroup = props.isGroup
    // answersByItem = answersByItemAll[itemId]
    // selectedAnswer = selectedAnswer
    // completed = completed
    
    return (
      <div className={cardClass}>
        <Card>

          <div className="prev-nav-link">
            <ItemBasicNav
              itemNumber={props.itemNumber}
              lastItemNumber={props.lastItemNumber}
              isGroup={props.isGroup}
              assessmentId={props.assessmentId}
              selectedStudent={props.selectedStudent}
              prev={true}
              completed={props.completed}
              disabled={true}
            />
          </div>

          <CardBody>



            <div className='question-number'>
              {item ? `Question ${itemNumber} of ${lastItemNumber}` : null}
            </div>
            <ItemQuestion question={item ? item.question : null} />
            {/* <ItemAnswers
              item={item}
              selectedAnswer={selectedAnswer}
              completed={completed}
            /> */}
            <ItemAnswers 
              activeItem={item}
              isGroup={props.isGroup}
              answersByItem={answersByItemAll && answersByItemAll[itemId]}
              selectedAnswer={selectedAnswer}
              completed={completed}
            />
            {completed &&
              <ItemFeedback 
                feedback={feedback}
                completed={completed}
              />
            }
          </CardBody>

          <div className="next-nav-link">
            <ItemBasicNav
              itemNumber={props.itemNumber}
              lastItemNumber={props.lastItemNumber}
              isGroup={props.isGroup}
              assessmentId={props.assessmentId}
              selectedStudent={props.selectedStudent}
              next={true}
              completed={props.completed}
              handleChangeItem={this.handleChangeItem}
              disabled={true}
            />
          </div>



        </Card>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    items: state.assessment.items,
  }),
  (dispatch) => bindActionCreators({ ...assessmentActionCreators }, dispatch)
)(AssessItemPreview)


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessItemPreview.js